import React from 'react';
import { formatMoney } from '../utils/money';
import { normalizeCurrency } from '../utils/currencyStyles';
import CurrencyBadge from './CurrencyBadge';

/**
 * Muestra monto en moneda original + badge.
 * Si es USD/EUR, el equivalente ARS va en una segunda línea (más chica).
 */
const MoneyDisplay = ({
  amount,
  currency = 'ARS',
  arsAmount,
  tipoCambio,
  modoOscuro = false,
  align = 'right',
  size = 'md',
  showBadge = true,
  className = '',
}) => {
  const c = normalizeCurrency(currency);
  const isForeign = c !== 'ARS';
  const amountClass = size === 'lg' ? 'text-base font-bold' : size === 'sm' ? 'text-xs font-semibold' : 'text-sm font-semibold';
  const alignClass = align === 'left' ? 'items-start text-left' : 'items-end text-right';

  return (
    <div className={`flex flex-col gap-0.5 ${alignClass} ${className}`}>
      <div className={`flex items-center gap-1.5 ${align === 'right' ? 'justify-end' : 'justify-start'}`}>
        {showBadge && isForeign && <CurrencyBadge currency={c} modoOscuro={modoOscuro} size="xs" />}
        <span className={amountClass}>{formatMoney(amount, c)}</span>
      </div>
      {isForeign && arsAmount != null && (
        <span className={`text-[10px] leading-tight ${modoOscuro ? 'text-gray-400' : 'text-gray-500'}`}>
          ≈ {formatMoney(arsAmount, 'ARS')}
          {tipoCambio ? ` · TC ${Number(tipoCambio).toLocaleString('es-AR')}` : ''}
        </span>
      )}
    </div>
  );
};

export default MoneyDisplay;
